module.exports = __webpack_public_path__ + "img/answer-bg.b166fed9.jpg";